//leaflet-control-layers-list paddingTop paddingBottom : 5

//CONSIDER: Hold down to search for a lot... Is that possible?

import { AddressQueryFields } from 'models/Address';
import BreadCrumbHeader from 'newComponents/BreadCrumbHeader';
import React from 'react';

import { useParams } from 'react-router-dom';
import DoNotCall from './DoNotCall';

  const DoNotCallPage = () => {

    const { addressID } = useParams();

    return (
      <div className="card">
         <BreadCrumbHeader/>
        <div className = "card-body" style={{paddingTop:10}}>
        <DoNotCall addressID={addressID}/>
        </div>
      </div>
    )

  }

  export default DoNotCallPage;